module.exports = __webpack_public_path__ + "static/media/saraiva_logo_black.49304193.png";